module.exports = __webpack_public_path__ + "img/logo-oca.43a7e8bc.webp";